import React from "react";
import Select from "../../../../Components/Common/Select/Select";
import Input from "../../../../Components/Common/Input/Input";
import ErrorMessage from "../../../../Components/Common/ErrorMessage/ErrorMessage";
import { ActionRow, ActionStatus } from "../types/precon.types";
import { CHAR_LIMIT } from "utils/Common/Constant";
import Table, { Column } from "Components/Table/Table";
import Button from "Components/Common/Button/Button";

const ACTION_STATUS_OPTIONS = [
  { value: "Pending", label: "Pending" },
  { value: "Complete", label: "Complete" },
  { value: "N/A", label: "N/A" },
];

interface ActionTableProps {
  rows: ActionRow[];
  onRowChange: (index: number, field: keyof ActionRow, value: string) => void;
  onAddRow: () => void;
  onRemoveRow: (index: number) => void;
  error?: string;
  touched?: boolean;
  rowErrors?: (string | undefined)[];
}

const ActionTable = ({
  rows,
  onRowChange,
  onAddRow,
  onRemoveRow,
  error,
  touched,
  rowErrors,
}: ActionTableProps) => {
  return (
    <div>
      <div className="tableScroll actionTableScroll">
        <Table
          tableClassName="actionTable"
          data={rows}
          columns={
            [
              {
                header: "Party",
                className: "partyCol",
                render: (row, i) => (
                  <Input
                    style={{ paddingLeft: "3px" }}
                    value={row.party}
                    placeholder="Party"
                    maxLength={CHAR_LIMIT.NAME}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      onRowChange(i, "party", e.target.value)
                    }
                  />
                ),
              },
              {
                header: "Action Item",
                render: (row, i) => (
                  <Input
                    style={{ padding: "5px" }}
                    value={row.action}
                    maxLength={CHAR_LIMIT.DESCRIPTION}
                    placeholder="Action item description"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      onRowChange(i, "action", e.target.value)
                    }
                  />
                ),
              },
              {
                header: "Status",
                className: "statusCol",
                render: (row, i) => (
                  <Select
                    className="selectStatus"
                    options={ACTION_STATUS_OPTIONS}
                    value={row.status}
                    onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
                      onRowChange(
                        i,
                        "status",
                        event.target.value as ActionStatus,
                      )
                    }
                  />
                ),
              },
              {
                header: "",
                render: (_, i) => (
                  <Button
                    type="button"
                    className="tableRemoveBtn"
                    onClick={() => onRemoveRow(i)}
                    title="Remove row"
                  >
                    <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
                      <path
                        d="M1 1l10 10M11 1L1 11"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                      />
                    </svg>
                  </Button>
                ),
              },
            ] as Column<ActionRow>[]
          }
        />
        {rowErrors?.[0] && (
          <span
            className="field-error"
            style={{ fontSize: 11, display: "block", marginTop: 2 }}
          >
            {rowErrors[0]}
          </span>
        )}
      </div>
      <div id="actionItems">
        <ErrorMessage touched={touched} error={error} />
      </div>
      <Button
        type="button"
        className="btn btnSecondary btnSm"
        onClick={onAddRow}
      >
        + Add Action Item
      </Button>
    </div>
  );
};

export default ActionTable;
